import { useEffect } from 'react';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { applySchemaDefaults } from '@plone/volto/helpers/Blocks/Blocks';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';

import { buttonSchema } from '../Button/schema';

import GroupButtonBody from './GroupButtonBody';
import GroupButtonData from './GroupButtonData';

const Edit = (props) => {
  const { data, block, selected, intl, onChangeBlock, isEditMode } = props;

  useEffect(() => {
    if (!data.buttons) {
      const buttonDefault = applySchemaDefaults({
        data: {
          '@id': uuid(),
        },
        schema: buttonSchema({ intl }),
        intl,
      });
      const newData = {
        ...data,
        buttons: [buttonDefault],
      };
      onChangeBlock(block, newData);
    }
  }, [data, isEditMode, block, onChangeBlock, intl]);

  return (
    <>
      <GroupButtonBody id={block} {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <GroupButtonData key={block} {...props} />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
  selected: PropTypes.bool,
};

export default Edit;
